import styled from 'styled-components';

import colors from '../../../../../../../../styles/colors';
import Button from '../../../../../../../../components/Button';

const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const ActionButton = styled(Button)`
  color: ${colors.base.alpha};
  :hover {
    background-color: ${colors.base.secondary};
  }
  border-radius: 84px;
  height: 36px;
  font-weight: 400;
  padding: 9px 14px;
  font-size: 12px;
  letter-spacing: 0;
  text-transform: none;
  text-wrap: nowrap;
  min-width: unset;
  width: fit-content;
  gap: 8px;
  
  /* TODO: We have to standardize all buttons and colors, to avoid having hardcoded values */
  background-color: ${({ provider }) => {
    switch (provider) {
      case 'msg':
        return colors.shades.success3;
      case 'email':
        return colors.base.warning;
      case 'sentToReschedule':
        return colors.shades.primary2;
      case 'rescheduledManually':
        return colors.shades.success2;
      case 'noShow':
        return colors.shades.danger1;
      case 'cancelMeeting':
        return colors.shades.danger3;
      case 'chat':
        return colors.base.secondary;
      case 'logACall':
        return colors.shades.gamma10;
      default:
        return colors.shades.alpha1;
    }
  }};
`;

export {
  ActionButton,
  ButtonsContainer,
};
